import "./SecurityBenefit.css";
import img from "../securityassets/securitybenefit.png";

const securityChooseList = [
  {
    num: "01",
    title: "Shift-Left Security",
    description:
      "Security checks are integrated early in development, enabling faster detection and remediation of vulnerabilities before they reach production environments.",
  },
  {
    num: "02",
    title: "Continuous Compliance",
    description:
      "Automated compliance checks ensure regulatory requirements are continuously met without disrupting development speed or release timelines.",
  },
  {
    num: "03",
    title: "Reduced Risk & Vulnerabilities",
    description:
      "Proactive threat detection and automated controls minimize security risks across applications, infrastructure, and deployment pipelines.",
  },
  {
    num: "04",
    title: "Improved Operational Confidence",
    description:
      "Secure, stable releases increase confidence in deployments and reduce incidents across development, testing, and production environments.",
  },
  {
    num: "05",
    title: "Improved Operational Confidence",
    description:
      "Secure, stable releases increase confidence in deployments and reduce incidents across development, testing, and production environments.",
  },
  {
    num: "06",
    title: "Improved Operational Confidence",
    description:
      "Secure, stable releases increase confidence in deployments and reduce incidents across development, testing, and production environments.",
  },
];

export default function SecurityBenefit() {
  return (
    <div id="security-benefit" className="outsourcemainclass">
      <h1 className="heading">
        Benefits of BastionEx Security & Compliance Services
      </h1>

      <p className="subheading">
        Delivering automated, scalable, and resilient orchestration solutions to
        efficiently manage containers, services, and workflows across modern
        distributed environments.
      </p>

      <div className="security-content">
        <div className="left">
          <img src={img} alt="Security Benefits" />
        </div>

        <div className="right">
          <ul>
            {securityChooseList.map((item, index) => (
              <li key={index}>
                <span className="image">
                  <span className="img">{item.num}</span>
                </span>

                <div className="text">
                  <p>{item.title}</p>
                  <span>{item.description}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
